/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 738:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.BadgeIcon = exports["default"] = exports.JustifyContent = exports.ButtonKinds = void 0;

var _jsxRuntime = __webpack_require__(893);

var _react = _interopRequireDefault(__webpack_require__(619));

var _styledComponents = _interopRequireDefault(__webpack_require__(459));

var _Typography = __webpack_require__(924);

var _ColorUtils = __webpack_require__(941);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var COLOR_DIFF = -50;
var ButtonKinds;
exports.ButtonKinds = ButtonKinds;

(function (ButtonKinds) {
  ButtonKinds["inkBase"] = "inkBase";
  ButtonKinds["primary"] = "primary";
  ButtonKinds["clean"] = "clean";
  ButtonKinds["secondary"] = "secondary";
  ButtonKinds["debug"] = "debug";
  ButtonKinds["alert"] = "alert";
})(ButtonKinds || (exports.ButtonKinds = ButtonKinds = {}));

var JustifyContent;
exports.JustifyContent = JustifyContent;

(function (JustifyContent) {
  JustifyContent["start"] = "start";
  JustifyContent["center"] = "center";
  JustifyContent["space-between"] = "space-between";
  JustifyContent["space-around"] = "space-around";
  JustifyContent["space-evenly"] = "space-evenly";
})(JustifyContent || (exports.JustifyContent = JustifyContent = {}));

var ParentButton = _styledComponents["default"].button.withConfig({
  displayName: "ParentButton",
  componentId: "-1ri4jgn"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 0;\n  padding: 14px 28px;\n  min-height: 48px;\n  min-width: 48px;\n  width: ", ";\n  cursor: pointer;\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: ", ";\n  gap: 8px;\n  &:disabled {\n    cursor: not-allowed;\n  }\n"], ["\n  border: 0;\n  padding: 14px 28px;\n  min-height: 48px;\n  min-width: 48px;\n  width: ", ";\n  cursor: pointer;\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: ", ";\n  gap: 8px;\n  &:disabled {\n    cursor: not-allowed;\n  }\n"])), function (_a) {
  var wide = _a.wide,
      width = _a.width;
  return wide ? '100%' : width ? width + "px" : 'auto';
}, function (_a) {
  var justifyContent = _a.justifyContent;
  return justifyContent || 'center';
});

var PrimaryButton = (0, _styledComponents["default"])(ParentButton).withConfig({
  displayName: "PrimaryButton",
  componentId: "-e78zlg"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 120px;\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    box-shadow: none;\n  }\n"], ["\n  border-radius: 120px;\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    box-shadow: none;\n  }\n"])), function (_a) {
  var theme = _a.theme,
      shadow = _a.shadow;
  return shadow ? "0 5px " + (0, _ColorUtils.changeColorShade)(theme.colors.orangeBase, COLOR_DIFF) : 'none';
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.whiteBase;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.orangeBase;
}, function (_a) {
  var theme = _a.theme;
  return (0, _ColorUtils.changeColorShade)(theme.colors.orangeBase, COLOR_DIFF / 4);
}, function (_a) {
  var theme = _a.theme;
  return (0, _ColorUtils.changeColorShade)(theme.colors.orangeBase, COLOR_DIFF);
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.coolGray95;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.coolGray62;
});
var AlertButton = (0, _styledComponents["default"])(ParentButton).withConfig({
  displayName: "AlertButton",
  componentId: "-pivvds"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-radius: 120px;\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    box-shadow: none;\n  }\n"], ["\n  border-radius: 120px;\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    box-shadow: none;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.whiteBase;
}, function (_a) {
  var theme = _a.theme;
  return theme.colorTokens.interactive['interactive-alert-default'];
}, function (_a) {
  var theme = _a.theme;
  return theme.colorTokens.interactive['interactive-alert-hovered'];
}, function (_a) {
  var theme = _a.theme;
  return theme.colorTokens.interactive['interactive-alert-hovered'];
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.coolGray95;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.coolGray62;
});
var DebugButton = (0, _styledComponents["default"])(ParentButton).withConfig({
  displayName: "DebugButton",
  componentId: "-obgdcj"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-radius: 120px;\n  border: 1px dashed ", ";\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    box-shadow: none;\n  }\n"], ["\n  border-radius: 120px;\n  border: 1px dashed ", ";\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    box-shadow: none;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.greenBase;
}, function (_a) {
  var theme = _a.theme,
      shadow = _a.shadow;
  return shadow ? "0 5px " + (0, _ColorUtils.changeColorShade)(theme.colors.greenBase, COLOR_DIFF) : 'none';
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.greenBase;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.oatBase;
}, function (_a) {
  var theme = _a.theme;
  return (0, _ColorUtils.changeColorShade)(theme.colors.oatBase, COLOR_DIFF / 4);
}, function (_a) {
  var theme = _a.theme;
  return (0, _ColorUtils.changeColorShade)(theme.colors.oatBase, COLOR_DIFF);
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.coolGray95;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.coolGray62;
});
var InkBaseButton = (0, _styledComponents["default"])(ParentButton).withConfig({
  displayName: "InkBaseButton",
  componentId: "-t1iy52"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border-radius: 100px;\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  border-radius: 100px;\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.oatBase;
}, function (_a) {
  var theme = _a.theme;
  return (0, _ColorUtils.hexToRGB)(theme.colors.oatBase, .1);
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.inkBase;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.oatBase;
}, function (_a) {
  var theme = _a.theme;
  return (0, _ColorUtils.changeColorShade)(theme.colors.oatBase, COLOR_DIFF);
}, function (_a) {
  var theme = _a.theme;
  return (0, _ColorUtils.changeColorShade)(theme.colors.oatBase, COLOR_DIFF);
}, function (_a) {
  var theme = _a.theme;
  return (0, _ColorUtils.hexToRGB)(theme.colors.oatBase, .1);
});
var SecondaryButton = (0, _styledComponents["default"])(ParentButton).withConfig({
  displayName: "SecondaryButton",
  componentId: "-cjjdhn"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  border-radius: 120px;\n  border: 1px solid ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  color: ", ";\n  border-radius: 120px;\n  border: 1px solid ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orangeBase;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.neutral[100];
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.whiteBase;
}, function (_a) {
  var theme = _a.theme;
  return (0, _ColorUtils.changeColorShade)(theme.colors.whiteBase, COLOR_DIFF / 4);
}, function (_a) {
  var theme = _a.theme;
  return (0, _ColorUtils.changeColorShade)(theme.colors.whiteBase, COLOR_DIFF);
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.coolGray82;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.whiteBase;
});
var CleanButton = (0, _styledComponents["default"])(ParentButton).withConfig({
  displayName: "CleanButton",
  componentId: "-1xsf8i2"
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: inherit;\n  background: inherit;\n"], ["\n  color: inherit;\n  background: inherit;\n"])));

var Badge = _styledComponents["default"].span.withConfig({
  displayName: "Badge",
  componentId: "-bgz7bj"
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: inline-block;\n  svg {\n    display: block;\n  }\n"], ["\n  display: inline-block;\n  svg {\n    display: block;\n  }\n"])));

var LeftBadge = (0, _styledComponents["default"])(Badge).withConfig({
  displayName: "LeftBadge",
  componentId: "-1qcwsqt"
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  float: left;\n"], ["\n  float: left;\n"])));
var RightBadge = (0, _styledComponents["default"])(Badge).withConfig({
  displayName: "RightBadge",
  componentId: "-ztaas3"
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  float: right;\n"], ["\n  float: right;\n"])));
var TextContent = (0, _styledComponents["default"])(_Typography.BodyText2SemiBold).withConfig({
  displayName: "TextContent",
  componentId: "-gh5esl"
})(templateObject_11 || (templateObject_11 = __makeTemplateObject([""], [""])));

var Button = /*#__PURE__*/_react["default"].forwardRef(function (_a, ref) {
  var children = _a.children,
      kind = _a.kind,
      leftBadge = _a.leftBadge,
      rightBadge = _a.rightBadge,
      buttonProps = __rest(_a, ["children", "kind", "leftBadge", "rightBadge"]);

  var BaseComponent;

  switch (kind) {
    case ButtonKinds.inkBase:
      BaseComponent = InkBaseButton;
      break;

    case ButtonKinds.clean:
      BaseComponent = CleanButton;
      break;

    case ButtonKinds.secondary:
      BaseComponent = SecondaryButton;
      break;

    case ButtonKinds.debug:
      BaseComponent = DebugButton;
      break;

    case ButtonKinds.alert:
      BaseComponent = AlertButton;
      break;

    case ButtonKinds.primary:
    default:
      BaseComponent = PrimaryButton;
  }

  return (0, _jsxRuntime.jsxs)(BaseComponent, __assign({
    ref: ref
  }, buttonProps, {
    children: [leftBadge && (0, _jsxRuntime.jsx)(LeftBadge, __assign({
      "data-name": 'button-left-badge'
    }, {
      children: leftBadge
    }), void 0), (0, _jsxRuntime.jsx)(TextContent, __assign({
      "data-name": 'button-content'
    }, {
      children: children
    }), void 0), rightBadge && (0, _jsxRuntime.jsx)(RightBadge, __assign({
      "data-name": 'button-right-badge'
    }, {
      children: rightBadge
    }), void 0)]
  }), void 0);
});

var _default = Button;
/** To be used when icons are 32px viewbox, but should occupy 24px space, while keeping icon size as 32px large */

exports["default"] = _default;

var BadgeIcon = _styledComponents["default"].span.withConfig({
  displayName: "BadgeIcon",
  componentId: "-oujsm6"
})(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  position: relative;\n  display: block;\n  width: 24px;\n  height: 24px;\n  > svg {\n    position: absolute;\n    font-size: 32px;\n    left: -4px;\n    top: -4px;\n  }\n"], ["\n  position: relative;\n  display: block;\n  width: 24px;\n  height: 24px;\n  > svg {\n    position: absolute;\n    font-size: 32px;\n    left: -4px;\n    top: -4px;\n  }\n"])));

exports.BadgeIcon = BadgeIcon;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;

/***/ }),

/***/ 305:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Button", ({
  enumerable: true,
  get: function get() {
    return _Button["default"];
  }
}));
Object.defineProperty(exports, "BadgeIcon", ({
  enumerable: true,
  get: function get() {
    return _Button.BadgeIcon;
  }
}));

var _Button = _interopRequireWildcard(__webpack_require__(738));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***/ }),

/***/ 804:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.constantColors = exports.c400 = exports.c300 = exports.c200 = exports.c150 = exports.c100 = exports.black = exports.white = void 0;
// Outdated since September 2024. Please use tokens.ts
var white = '#FFFFFF';
exports.white = white;
var black = '#0F0B0A';
exports.black = black;
var c100 = 'rgba(255, 255, 255, 0.1)';
exports.c100 = c100;
var c150 = 'rgba(255, 255, 255, 0.2)';
exports.c150 = c150;
var c200 = 'rgba(255, 255, 255, 0.4)';
exports.c200 = c200;
var c300 = 'rgba(255, 255, 255, 0.8)';
exports.c300 = c300;
var c400 = 'rgba(255, 255, 255, 0.9)';
exports.c400 = c400;
var constantColors = {
  white: white,
  black: black,
  c100: c100,
  c150: c150,
  c200: c200,
  c300: c300,
  c400: c400
};
exports.constantColors = constantColors;

/***/ }),

/***/ 635:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.extendedPalette = exports.grayburst44Gradient = exports.grayburst82Gradient = exports.plumburstGradient = exports.kaleburstGradient = exports.tealburstGradient = exports.sunburst43Gradient = exports.sunburstGradient = exports.moonshineGradient = exports.yolkBase = exports.yolk76 = exports.whiteBase = exports.warmGray98 = exports.warmGray92 = exports.warmGray82 = exports.warmGray64 = exports.warmGray48 = exports.tomatoBase = exports.tealBase = exports.plumBase = exports.orangeBase = exports.orange72 = exports.orange49 = exports.orange43 = exports.oatBase = exports.kaleBase = exports.inkBase = exports.ink30 = exports.ink24 = exports.ink06 = exports.greenBase = exports.green91 = exports.coolGray95 = exports.coolGray92 = exports.coolGray82 = exports.coolGray62 = exports.coolGray44 = exports.blackBase = void 0;
// Outdated since September 2024. Please use tokens.ts
var blackBase = '#000000';
exports.blackBase = blackBase;
var coolGray44 = '#6c7075'; // formerly coolGray48

exports.coolGray44 = coolGray44;
var coolGray62 = '#9a9ea2'; // formerly coolGray60

exports.coolGray62 = coolGray62;
var coolGray82 = '#cdd1d4';
exports.coolGray82 = coolGray82;
var coolGray92 = '#e6eaed';
exports.coolGray92 = coolGray92;
var coolGray95 = '#f2f4f5';
exports.coolGray95 = coolGray95;
var green91 = '#ddf4da';
exports.green91 = green91;
var greenBase = '#03a057';
exports.greenBase = greenBase;
var ink06 = '#030f1a';
exports.ink06 = ink06;
var ink24 = '#273f54';
exports.ink24 = ink24;
var ink30 = '#2e4d69';
exports.ink30 = ink30;
var inkBase = '#0e2337';
exports.inkBase = inkBase;
var kaleBase = '#0ccaa8';
exports.kaleBase = kaleBase;
var oatBase = '#fcfaf4';
exports.oatBase = oatBase;
var orange43 = '#c74013';
exports.orange43 = orange43;
var orange49 = '#de4b1b';
exports.orange49 = orange49;
var orange72 = '#fc9473';
exports.orange72 = orange72;
var orangeBase = '#fd6533';
exports.orangeBase = orangeBase;
var plumBase = '#4311D1';
exports.plumBase = plumBase;
var tealBase = '#04b8f1';
exports.tealBase = tealBase;
var tomatoBase = '#dc043a';
exports.tomatoBase = tomatoBase;
var warmGray48 = '#7d7979';
exports.warmGray48 = warmGray48;
var warmGray64 = '#a7a1a0';
exports.warmGray64 = warmGray64;
var warmGray82 = '#d5cfcd';
exports.warmGray82 = warmGray82;
var warmGray92 = '#ede8e6';
exports.warmGray92 = warmGray92;
var warmGray98 = '#fbf9f9';
exports.warmGray98 = warmGray98;
var whiteBase = '#ffffff';
exports.whiteBase = whiteBase;
var yolk76 = '#f8dd8c';
exports.yolk76 = yolk76;
var yolkBase = '#ffcd3d'; // gradients

exports.yolkBase = yolkBase;
var moonshineGradient = "linear-gradient(203.67deg, " + ink30 + " 6.25%, " + inkBase + " 89.1%)";
exports.moonshineGradient = moonshineGradient;
var sunburstGradient = "linear-gradient(203.67deg, " + yolkBase + " 5.33%, " + orangeBase + " 88.22%)";
exports.sunburstGradient = sunburstGradient;
var sunburst43Gradient = 'linear-gradient(198.37deg, #f98a23 6.2%, #c74013 82.71%)';
exports.sunburst43Gradient = sunburst43Gradient;
var tealburstGradient = 'linear-gradient(198.37deg, #11c6ff 6.2%, #0098da 82.71%)';
exports.tealburstGradient = tealburstGradient;
var kaleburstGradient = 'linear-gradient(198.37deg, #0be5be 6.2%, #11bfa0 82.71%);';
exports.kaleburstGradient = kaleburstGradient;
var plumburstGradient = 'linear-gradient(198.37deg, #8b6dff 6.2%, #4311f1 82.71%)';
exports.plumburstGradient = plumburstGradient;
var grayburst82Gradient = 'linear-gradient(198.37deg, #f6f9fb 6.2%, #cdd1d4 82.71%)';
exports.grayburst82Gradient = grayburst82Gradient;
var grayburst44Gradient = "linear-gradient(198.37deg, " + coolGray92 + " 6.2%, " + coolGray44 + " 82.71%)";
exports.grayburst44Gradient = grayburst44Gradient;
var extendedPalette = {
  blackBase: blackBase,
  coolGray44: coolGray44,
  coolGray62: coolGray62,
  coolGray82: coolGray82,
  coolGray92: coolGray92,
  coolGray95: coolGray95,
  green91: green91,
  greenBase: greenBase,
  ink06: ink06,
  ink24: ink24,
  ink30: ink30,
  inkBase: inkBase,
  kaleBase: kaleBase,
  oatBase: oatBase,
  orange43: orange43,
  orange49: orange49,
  orange72: orange72,
  orangeBase: orangeBase,
  plumBase: plumBase,
  tealBase: tealBase,
  tomatoBase: tomatoBase,
  warmGray48: warmGray48,
  warmGray64: warmGray64,
  warmGray82: warmGray82,
  warmGray92: warmGray92,
  warmGray98: warmGray98,
  whiteBase: whiteBase,
  yolk76: yolk76,
  yolkBase: yolkBase,
  moonshineGradient: moonshineGradient,
  sunburstGradient: sunburstGradient,
  sunburst43Gradient: sunburst43Gradient,
  tealburstGradient: tealburstGradient,
  kaleburstGradient: kaleburstGradient,
  plumburstGradient: plumburstGradient,
  grayburst82Gradient: grayburst82Gradient,
  grayburst44Gradient: grayburst44Gradient
};
exports.extendedPalette = extendedPalette;

/***/ }),

/***/ 909:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.gameBackgroundColors = exports.wordSnatchers = exports.wordBubbles = exports.troubleBrewing = exports.trainOfThought = exports.topThat = exports.tidalTreasures = exports.takingRoot = exports.starSearch = exports.splittingSeeds = exports.speedPack = exports.speedMatchOverdrive = exports.speedMatch = exports.spatialSpeedMatch = exports.spaceTrace = exports.skyrise = exports.robotFactory = exports.riverRanger = exports.raindrops = exports.playingKoi = exports.piratePassage = exports.pinballRecall = exports.penguinPursuit = exports.organicOrder = exports.memoryServes = exports.memoryMatrix = exports.memoryMatchOverdrive = exports.memoryMatch = exports.masterpiece = exports.magicChance = exports.lostInMigration = exports.highwayHazards = exports.halveYourCake = exports.fuseClues = exports.feelTheBeat = exports.editorsChoice = exports.ebbAndFlow = exports.eagleEye = exports.disillusion = exports.continuum = exports.contextual = exports.colorMatch = exports.chalkboardChallenge = exports.brainShiftOverdrive = exports.brainShift = exports.assistAnts = void 0;

/***************** Game Background Colors *****************/
var assistAnts = '#33A05F';
exports.assistAnts = assistAnts;
var brainShift = '#005940';
exports.brainShift = brainShift;
var brainShiftOverdrive = '#004932';
exports.brainShiftOverdrive = brainShiftOverdrive;
var chalkboardChallenge = '#005940';
exports.chalkboardChallenge = chalkboardChallenge;
var colorMatch = '#0E2337';
exports.colorMatch = colorMatch;
var contextual = '#0E2337';
exports.contextual = contextual;
var continuum = '#094441';
exports.continuum = continuum;
var disillusion = '#054450';
exports.disillusion = disillusion;
var eagleEye = '#48A77A';
exports.eagleEye = eagleEye;
var ebbAndFlow = '#003C82';
exports.ebbAndFlow = ebbAndFlow;
var editorsChoice = '#413834';
exports.editorsChoice = editorsChoice;
var feelTheBeat = '#3B2F84';
exports.feelTheBeat = feelTheBeat;
var fuseClues = '#196E6E';
exports.fuseClues = fuseClues;
var halveYourCake = '#A44522';
exports.halveYourCake = halveYourCake;
var highwayHazards = '#7D2709';
exports.highwayHazards = highwayHazards;
var lostInMigration = '#48A4B7';
exports.lostInMigration = lostInMigration;
var magicChance = '#374884';
exports.magicChance = magicChance;
var masterpiece = '#ee9528';
exports.masterpiece = masterpiece;
var memoryMatch = '#196E6E';
exports.memoryMatch = memoryMatch;
var memoryMatchOverdrive = '#003332';
exports.memoryMatchOverdrive = memoryMatchOverdrive;
var memoryMatrix = '#5A322B';
exports.memoryMatrix = memoryMatrix;
var memoryServes = '#3C2C3E';
exports.memoryServes = memoryServes;
var organicOrder = '#48A77A';
exports.organicOrder = organicOrder;
var penguinPursuit = '#70DFDD';
exports.penguinPursuit = penguinPursuit;
var pinballRecall = '#001626';
exports.pinballRecall = pinballRecall;
var piratePassage = '#18C4BC';
exports.piratePassage = piratePassage;
var playingKoi = '#2076BC';
exports.playingKoi = playingKoi;
var raindrops = '#3AC0D1';
exports.raindrops = raindrops;
var riverRanger = '#57B7F2';
exports.riverRanger = riverRanger;
var robotFactory = '#c07237';
exports.robotFactory = robotFactory;
var skyrise = '#379EA6';
exports.skyrise = skyrise;
var spaceTrace = '#000420';
exports.spaceTrace = spaceTrace;
var spatialSpeedMatch = '#613656';
exports.spatialSpeedMatch = spatialSpeedMatch;
var speedMatch = '#00446D';
exports.speedMatch = speedMatch;
var speedMatchOverdrive = '#00446D';
exports.speedMatchOverdrive = speedMatchOverdrive;
var speedPack = '#B7802D';
exports.speedPack = speedPack;
var splittingSeeds = '#00693F';
exports.splittingSeeds = splittingSeeds;
var starSearch = '#0E2337';
exports.starSearch = starSearch;
var takingRoot = '#6D3226';
exports.takingRoot = takingRoot;
var tidalTreasures = '#374884';
exports.tidalTreasures = tidalTreasures;
var topThat = '#071C31';
exports.topThat = topThat;
var trainOfThought = '#2A802B';
exports.trainOfThought = trainOfThought;
var troubleBrewing = '#084C53';
exports.troubleBrewing = troubleBrewing;
var wordBubbles = '#0E2337';
exports.wordBubbles = wordBubbles;
var wordSnatchers = '#652B7D';
exports.wordSnatchers = wordSnatchers;
var gameBackgroundColors = {
  'assist-ants': assistAnts,
  'brain-shift': brainShift,
  'brain-shift-overdrive': brainShiftOverdrive,
  'chalkboard-challenge': chalkboardChallenge,
  'color-match': colorMatch,
  contextual: contextual,
  continuum: continuum,
  disillusion: disillusion,
  'eagle-eye': eagleEye,
  'ebb-and-flow': ebbAndFlow,
  'editors-choice': editorsChoice,
  'feel-the-beat': feelTheBeat,
  'fuse-clues': fuseClues,
  'halve-your-cake': halveYourCake,
  'highway-hazards': highwayHazards,
  'lost-in-migration': lostInMigration,
  'magic-chance': magicChance,
  'masterpiece': masterpiece,
  'memory-match': memoryMatch,
  'memory-match-overdrive': memoryMatchOverdrive,
  'memory-matrix': memoryMatrix,
  'memory-serves': memoryServes,
  'organic-order': organicOrder,
  'penguin-pursuit': penguinPursuit,
  'pinball-recall': pinballRecall,
  'pirate-passage': piratePassage,
  'playing-koi': playingKoi,
  raindrops: raindrops,
  'river-ranger': riverRanger,
  'robot-factory': robotFactory,
  skyrise: skyrise,
  'space-trace': spaceTrace,
  'spatial-speed-match': spatialSpeedMatch,
  'speed-match': speedMatch,
  'speed-match-overdrive': speedMatchOverdrive,
  'speed-pack': speedPack,
  'splitting-seeds': splittingSeeds,
  'star-search': starSearch,
  'taking-root': takingRoot,
  'tidal-treasures': tidalTreasures,
  'top-that': topThat,
  'train-of-thought': trainOfThought,
  'trouble-brewing': troubleBrewing,
  'word-bubbles': wordBubbles,
  'word-snatchers': wordSnatchers
};
exports.gameBackgroundColors = gameBackgroundColors;

/***/ }),

/***/ 34:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _constants = __webpack_require__(804);

Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});

var _extendedPalette = __webpack_require__(635);

Object.keys(_extendedPalette).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _extendedPalette[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _extendedPalette[key];
    }
  });
});

var _gameBackground = __webpack_require__(909);

Object.keys(_gameBackground).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _gameBackground[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _gameBackground[key];
    }
  });
});

var _tokens = __webpack_require__(358);

Object.keys(_tokens).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _tokens[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tokens[key];
    }
  });
});

var _primitives = __webpack_require__(190);

Object.keys(_primitives).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _primitives[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _primitives[key];
    }
  });
});

/***/ }),

/***/ 190:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.primitives = void 0;
// Primitives are based on figma
// https://www.figma.com/design/zZKijPEIGihIuWe4y0zqkH/%F0%9F%97%82%EF%B8%8F-Tokens%2C-Variables-%26-Styles?node-id=1057-54
var accent = {
  Error0: '#0a0002',
  Error10: '#330005',
  Error20: '#561019',
  Error30: '#6f2a2b',
  Error40: '#923a46',
  Error50: '#b8475b',
  Error60: '#ea4a67',
  Error70: '#ef768c',
  Error80: '#f4a4b2',
  Error90: '#fad1d9',
  Error95: '#fce8ec',
  Error98: '#fef6f7',
  Error100: '#ffffff',
  Primary0: '#1d0700',
  Primary10: '#330c00',
  Primary20: '#5a1802',
  Primary30: '#8b2503',
  Primary40: '#bd3305',
  Primary50: '#ee4912',
  Primary60: '#fa6432',
  Primary70: '#fb8760',
  Primary80: '#fcac91',
  Primary90: '#fed2c3',
  Primary95: '#fee5dc',
  Primary98: '#fff7f5',
  Primary100: '#ffffff',
  Secondary0: '#0A0800',
  Secondary10: '#332600',
  Secondary20: '#6f4e00',
  Secondary30: '#704e00',
  Secondary40: '#c8930e',
  Secondary50: '#dfa92a',
  Secondary60: '#ffcd3d',
  Secondary70: '#ffd670',
  Secondary80: '#ffe3a3',
  Secondary90: '#fff4d6',
  Secondary95: '#fff8e5',
  Secondary98: '#fffcf5',
  Secondary100: '#ffffff',
  Success0: '#020905',
  Success10: '#082b14',
  Success20: '#165029',
  Success30: '#108950',
  Success40: '#22ba72',
  Success50: '#33cc78',
  Success60: '#5fe2a4',
  Success70: '#8beabd',
  Success80: '#b6f2d5',
  Success90: '#d8f8e9',
  Success95: '#e9fbf3',
  Success98: '#f6fdfa',
  Success100: '#ffffff',
  Tertiary0: '#020808',
  Tertiary10: '#162221',
  Tertiary20: '#284341',
  Tertiary30: '#366865',
  Tertiary40: '#37958e',
  Tertiary50: '#36ccc1',
  Tertiary60: '#63d4cc',
  Tertiary70: '#88e2dc',
  Tertiary80: '#b2ebe7',
  Tertiary90: '#daf6f4',
  Tertiary95: '#ebfaf9',
  Tertiary98: '#f7fdfc',
  Tertiary100: '#ffffff'
};
var neutral = {
  Cool0: '#000000',
  Cool2: '#020508',
  Cool5: '#050d14',
  Cool10: '#0c1f31',
  Cool20: '#243342',
  Cool30: '#3f4d5a',
  Cool40: '#5c6670',
  Cool50: '#788087',
  Cool60: '#9a9ea2',
  Cool70: '#b5b8ba',
  Cool80: '#c9cccf',
  Cool90: '#e3e6e8',
  Cool95: '#f1f2f4',
  Cool98: '#f9fafa',
  Cool100: '#ffffff',
  Warm0: '#000000',
  Warm2: '#060504',
  Warm5: '#0f0d0b',
  Warm10: '#1e1a15',
  Warm20: '#3a332c',
  Warm30: '#564d43',
  Warm40: '#71665b',
  Warm50: '#8b7f74',
  Warm60: '#a5998d',
  Warm70: '#bcb2a9',
  Warm80: '#d3ccc5',
  Warm90: '#eae6e1',
  Warm95: '#f4f2f1',
  Warm98: '#fdfcf9',
  Warm100: '#ffffff'
};
var games = {
  AssistAnts: '#5bc988',
  BrainShift: '#005940',
  BrainShiftOverdrive: '#004932',
  ChalkboardChallenge: '#005940',
  ColorMatch: '#0e2337',
  Contextual: '#0e2337',
  Continuum: '#094441',
  Disillusion: '#054450',
  EbbAndFlow: '#003c82',
  EditorSChoice: '#413834',
  FeelTheBeat: '#3b2f84',
  FuseClues: '#196e6e',
  HalveYourCake: '#a44522',
  HighwayHazards: '#7d2709',
  LostInMigration: '#48a4b7',
  MagicChance: '#00323f',
  Masterpiece: '#374884',
  MemoryMatch: '#196e6e',
  MemoryMatchOverdrive: '#003332',
  MemoryMatrix: '#5a322b',
  MemoryServes: '#9151ed',
  OrganicOrder: '#48a77a',
  PenguinPursuit: '#70dfdd',
  PetDetective: '#303030',
  PinballRecall: '#001626',
  PiratePassage: '#23b3ab',
  PlayingKoi: '#2076bc',
  Raindrops: '#28a7b8',
  RiverRanger: '#57b7f2',
  Skyrise: '#379ea6',
  SpaceTrace: '#000420',
  SpatialSpeedMatch: '#613656',
  SpeedMatch: '#00446d',
  SpeedMatchOverdrive: '#00446d',
  SpeedPack: '#b7802d',
  SplittingSeeds: '#00693f',
  StarSearch: '#0e2337',
  TakingRoot: '#6d3226',
  TidalTreasures: '#17305e',
  TopThat: '#071c31',
  TrainOfThought: '#2a802b',
  TroubleBrewing: '#084c53',
  WordBubbles: '#0e2337',
  WordSnatchers: '#652b7d'
};
var key = {
  Primary: accent.Primary60,
  Secondary: accent.Secondary60,
  Tertiary: accent.Tertiary50,
  Success: accent.Success40,
  Error: accent.Error60,
  Cool: neutral.Cool10,
  Warm: neutral.Warm98
};
var primitives = {
  accent: accent,
  neutral: neutral,
  games: games,
  key: key
};
exports.primitives = primitives;

/***/ }),

/***/ 358:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.dark = exports.light = void 0;

var _primitives = __webpack_require__(190);

var light = {
  colors: {
    background: {
      'background-default': _primitives.primitives.neutral.Warm98,
      'background-subdued': _primitives.primitives.neutral.Warm95,
      'background-bright': _primitives.primitives.neutral.Warm100,
      'background-invert': _primitives.primitives.neutral.Cool5
    },
    accent: {
      primary: _primitives.primitives.key.Primary,
      secondary: _primitives.primitives.key.Secondary,
      tertiary: _primitives.primitives.key.Tertiary,
      success: _primitives.primitives.key.Success,
      alert: _primitives.primitives.key.Error
    },
    surface: {
      'surface-default': _primitives.primitives.neutral.Warm100,
      'surface-subdued': _primitives.primitives.neutral.Warm95,
      'surface-depressed': _primitives.primitives.neutral.Warm90,
      'surface-invert': _primitives.primitives.neutral.Cool20,
      'surface-success': _primitives.primitives.accent.Success95,
      'surface-alert': _primitives.primitives.accent.Error95
    },
    interactive: {
      'interactive-filled-default': _primitives.primitives.accent.Primary60,
      'interactive-filled-hovered': _primitives.primitives.accent.Primary40,
      'interactive-filled-depressed': _primitives.primitives.accent.Primary20,
      'interactive-filled-disabled': _primitives.primitives.neutral.Cool90,
      'interactive-bordered-default': _primitives.primitives.neutral.Cool100,
      'interactive-bordered-hovered': _primitives.primitives.neutral.Cool90,
      'interactive-bordered-depressed': _primitives.primitives.neutral.Cool70,
      'interactive-bordered-disabled': _primitives.primitives.neutral.Cool98,
      'interactive-alert-default': _primitives.primitives.accent.Error60,
      'interactive-alert-hovered': _primitives.primitives.accent.Error50
    },
    text: {
      'text-default': _primitives.primitives.neutral.Cool10,
      'text-subdued': _primitives.primitives.neutral.Cool40,
      'text-disabled': _primitives.primitives.neutral.Cool70,
      'text-interactive': _primitives.primitives.accent.Primary60,
      'text-on-interactive': _primitives.primitives.neutral.Warm100,
      'text-on-invert': _primitives.primitives.neutral.Cool95,
      'text-success': _primitives.primitives.accent.Success40,
      'text-alert': _primitives.primitives.accent.Error60
    },
    icon: {
      'icon-default': _primitives.primitives.neutral.Cool10,
      'icon-subdued': _primitives.primitives.neutral.Cool40,
      'icon-disabled': _primitives.primitives.neutral.Cool70,
      'icon-interactive': _primitives.primitives.accent.Primary60,
      'icon-on-interactive': _primitives.primitives.accent.Primary100,
      'icon-success': _primitives.primitives.accent.Success40,
      'icon-alert': _primitives.primitives.accent.Error60
    },
    border: {
      'border-default': _primitives.primitives.neutral.Cool70,
      'border-subdued': _primitives.primitives.neutral.Cool90,
      'border-disabled': _primitives.primitives.neutral.Cool95,
      'border-interactive': _primitives.primitives.accent.Primary60,
      'border-success': _primitives.primitives.accent.Success40,
      'border-alert': _primitives.primitives.accent.Error60
    },
    decorative: {
      'decorative-icon-one': _primitives.primitives.accent.Error70,
      'decorative-surface-one': _primitives.primitives.accent.Tertiary70,
      'decorative-surface-two': _primitives.primitives.accent.Secondary60
    }
  }
};
exports.light = light;
var dark = {
  colors: {
    background: {
      'background-default': _primitives.primitives.neutral.Cool10,
      'background-subdued': _primitives.primitives.neutral.Cool5,
      'background-bright': _primitives.primitives.neutral.Cool20,
      'background-invert': _primitives.primitives.neutral.Cool5
    },
    accent: {
      primary: _primitives.primitives.accent.Primary70,
      secondary: _primitives.primitives.accent.Secondary70,
      tertiary: _primitives.primitives.accent.Tertiary60,
      success: _primitives.primitives.accent.Success80,
      alert: _primitives.primitives.accent.Error70
    },
    surface: {
      'surface-default': _primitives.primitives.neutral.Cool20,
      'surface-subdued': _primitives.primitives.neutral.Cool10,
      'surface-depressed': _primitives.primitives.neutral.Cool5,
      'surface-invert': _primitives.primitives.neutral.Cool20,
      'surface-success': _primitives.primitives.accent.Success10,
      'surface-alert': _primitives.primitives.accent.Error10
    },
    interactive: {
      'interactive-filled-default': _primitives.primitives.accent.Primary70,
      'interactive-filled-hovered': _primitives.primitives.accent.Primary50,
      'interactive-filled-depressed': _primitives.primitives.accent.Primary60,
      'interactive-filled-disabled': _primitives.primitives.neutral.Cool30,
      'interactive-bordered-default': _primitives.primitives.neutral.Cool20,
      'interactive-bordered-hovered': _primitives.primitives.neutral.Cool30,
      'interactive-bordered-depressed': _primitives.primitives.neutral.Cool5,
      'interactive-bordered-disabled': _primitives.primitives.neutral.Cool20,
      'interactive-alert-default': _primitives.primitives.accent.Error60,
      'interactive-alert-hovered': _primitives.primitives.accent.Error50
    },
    text: {
      'text-default': _primitives.primitives.neutral.Cool90,
      'text-subdued': _primitives.primitives.neutral.Cool70,
      'text-disabled': _primitives.primitives.neutral.Cool40,
      'text-interactive': _primitives.primitives.accent.Primary70,
      'text-on-interactive': _primitives.primitives.neutral.Cool98,
      'text-on-invert': _primitives.primitives.neutral.Cool60,
      'text-success': _primitives.primitives.accent.Success50,
      'text-alert': _primitives.primitives.accent.Error70
    },
    icon: {
      'icon-default': _primitives.primitives.neutral.Cool90,
      'icon-subdued': _primitives.primitives.neutral.Cool70,
      'icon-disabled': _primitives.primitives.neutral.Cool40,
      'icon-interactive': _primitives.primitives.accent.Primary70,
      'icon-on-interactive': _primitives.primitives.accent.Primary98,
      'icon-success': _primitives.primitives.accent.Success50,
      'icon-alert': _primitives.primitives.accent.Error70
    },
    border: {
      'border-default': _primitives.primitives.neutral.Cool50,
      'border-subdued': _primitives.primitives.neutral.Cool40,
      'border-disabled': _primitives.primitives.neutral.Cool30,
      'border-interactive': _primitives.primitives.accent.Primary70,
      'border-success': _primitives.primitives.accent.Success50,
      'border-alert': _primitives.primitives.accent.Error70
    },
    decorative: {
      'decorative-icon-one': _primitives.primitives.accent.Error80,
      'decorative-surface-one': _primitives.primitives.accent.Tertiary40,
      'decorative-surface-two': _primitives.primitives.accent.Secondary30
    }
  }
};
exports.dark = dark;

/***/ }),

/***/ 393:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _jsxRuntime = __webpack_require__(893);

var _react = __webpack_require__(619);

var _iframe = _interopRequireDefault(__webpack_require__(167));

var _GameCocosShared = __webpack_require__(0);

var _lodash = _interopRequireDefault(__webpack_require__(96));

var _styledComponents = _interopRequireDefault(__webpack_require__(459));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var GameCocosIframe = function GameCocosIframe(_a) {
  var _b = _a.aspectRatio,
      aspectRatio = _b === void 0 ? [4, 3] : _b,
      onEvent = _a.onEvent,
      _c = _a.onError,
      onError = _c === void 0 ? function () {
    return null;
  } : _c,
      url = _a.url,
      vars = _a.vars,
      _d = _a.visibility,
      visibility = _d === void 0 ? true : _d;
  var iframe = (0, _react.useRef)();
  var sendToIframe = (0, _react.useCallback)(function (data) {
    var _a, _b;

    data.lumos = true;
    (_b = (_a = iframe.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage(data, '*');
  }, []);

  var onResize = function onResize() {
    sendToIframe({
      command: 'resize',
      height: (0, _GameCocosShared.getHeight)(aspectRatio, iframe.current.clientWidth),
      width: iframe.current.clientWidth
    });
  };

  var onIframeLoad = (0, _react.useCallback)(function () {
    sendToIframe({
      command: 'init',
      url: url,
      vars: vars
    });
  }, []);
  var onMessageEvent = (0, _react.useCallback)(function (message) {
    var _a;

    if (!((_a = message === null || message === void 0 ? void 0 : message.data) === null || _a === void 0 ? void 0 : _a.lumos)) {
      return;
    }

    var _b = message.data,
        eventName = _b.eventName,
        eventData = _b.eventData;
    onEvent(eventName, eventData);
  }, []);
  (0, _react.useLayoutEffect)(function () {
    var _a;

    window.addEventListener('message', onMessageEvent);
    var throttledResize = (0, _lodash["default"])(onResize, _GameCocosShared.throttleResizeWait, {
      trailing: true
    });
    window.addEventListener('resize', throttledResize);
    (_a = iframe.current) === null || _a === void 0 ? void 0 : _a.setAttribute('srcdoc', _iframe["default"]); // ensure iframe has content on each remount

    return function () {
      var _a;

      window.removeEventListener('resize', throttledResize);
      window.removeEventListener('message', onMessageEvent);
      (_a = iframe.current) === null || _a === void 0 ? void 0 : _a.setAttribute('srcdoc', null);
    };
  }, []);
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: (0, _jsxRuntime.jsx)(IframeContainer, {
      as: 'iframe',
      props: {
        visibility: visibility,
        aspectRatio: aspectRatio
      },
      allow: 'autoplay',
      sandbox: 'allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox',
      frameBorder: '0',
      onLoad: onIframeLoad,
      onError: onError,
      ref: iframe,
      srcDoc: _iframe["default"]
    }, void 0)
  }, void 0);
};

var IframeContainer = _styledComponents["default"].div.withConfig({
  displayName: "IframeContainer",
  componentId: "-e60ak6"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  visibility: ", ";\n  aspect-ratio: ", ";\n"], ["\n  width: 100%;\n  visibility: ", ";\n  aspect-ratio: ", ";\n"])), function (_a) {
  var props = _a.props;
  return props.visibility ? 'visible' : 'hidden';
}, function (_a) {
  var props = _a.props;
  return props.aspectRatio[0] + '/' + props.aspectRatio[1];
});

var _default = GameCocosIframe;
exports["default"] = _default;
var templateObject_1;

/***/ }),

/***/ 0:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.throttleResizeWait = exports.getHeight = void 0;

var getHeight = function getHeight(aspectRatio, width) {
  return Math.round(width * aspectRatio[1] / aspectRatio[0]);
};

exports.getHeight = getHeight;
var throttleResizeWait = 100;
exports.throttleResizeWait = throttleResizeWait;

/***/ }),

/***/ 454:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _jsxRuntime = __webpack_require__(893);

var _react = __webpack_require__(619);

var _GameCocosShared = __webpack_require__(0);

var _lodash = _interopRequireDefault(__webpack_require__(96));

var _styledComponents = _interopRequireDefault(__webpack_require__(459));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var GameCocosWindow = function GameCocosWindow(_a) {
  var _b = _a.aspectRatio,
      aspectRatio = _b === void 0 ? [4, 3] : _b,
      url = _a.url,
      vars = _a.vars,
      _c = _a.visibility,
      visibility = _c === void 0 ? true : _c,
      onEvent = _a.onEvent,
      _d = _a.onError,
      onError = _d === void 0 ? function () {
    return null;
  } : _d;
  var gameContainerElement = (0, _react.useRef)(null);

  var onResize = function onResize() {
    var _a;

    if ((_a = window.cc) === null || _a === void 0 ? void 0 : _a.view) {
      window.cc.view.setCanvasSize(gameContainerElement.current.clientWidth, (0, _GameCocosShared.getHeight)(aspectRatio, gameContainerElement.current.clientWidth));
      window.cc.view.setDesignResolutionSize(window.cc.view._originalDesignResolutionSize.width, window.cc.view._originalDesignResolutionSize.height);
    }
  };

  (0, _react.useLayoutEffect)(onResize, [aspectRatio]);
  (0, _react.useLayoutEffect)(function () {
    var script = document.createElement('script');
    script.setAttribute('id', 'gameScript');
    script.setAttribute('ref', 'gameScript');
    script.setAttribute('src', url);
    script.onerror = onError;
    document.body.appendChild(script);
    window.Lumos = vars;

    window.sendToJavaScript = function (data, argData) {
      var _a = Array.isArray(data) ? data : [data, argData],
          eventName = _a[0],
          eventData = _a[1];

      if (onEvent) {
        onEvent(eventName, eventData);
      }
    };

    var throttledResize = (0, _lodash["default"])(onResize, _GameCocosShared.throttleResizeWait, {
      trailing: true
    });
    window.addEventListener('resize', throttledResize);
    return function () {
      var _a, _b, _c, _d, _e, _f;

      document.body.removeChild(script);
      window.Lumos = {};

      window.sendToJavaScript = function () {
        return;
      }; // Clear cocos3 scope


      (_b = (_a = window.cc) === null || _a === void 0 ? void 0 : _a.director) === null || _b === void 0 ? void 0 : _b.purgeCachedData();
      (_d = (_c = window.cc) === null || _c === void 0 ? void 0 : _c.director) === null || _d === void 0 ? void 0 : _d.purgeDirector();
      (_f = (_e = window.cc) === null || _e === void 0 ? void 0 : _e.director) === null || _f === void 0 ? void 0 : _f.end();
      window.removeEventListener('resize', throttledResize);
    };
  }, []);
  return (0, _jsxRuntime.jsx)(GameContainer, __assign({
    props: {
      aspectRatio: aspectRatio,
      visibility: visibility
    },
    ref: gameContainerElement,
    className: 'cocos3',
    id: 'game-manager'
  }, {
    children: (0, _jsxRuntime.jsx)("canvas", {
      id: 'gameCanvas',
      style: {
        visibility: visibility ? 'visible' : 'hidden'
      }
    }, void 0)
  }), void 0);
};

var GameContainer = _styledComponents["default"].div.withConfig({
  displayName: "GameContainer",
  componentId: "-la3sdt"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  visibility: ", ";\n  aspect-ratio: ", ";\n"], ["\n  visibility: ", ";\n  aspect-ratio: ", ";\n"])), function (_a) {
  var props = _a.props;
  return props.visibility ? 'visible' : 'hidden';
}, function (_a) {
  var props = _a.props;
  return props.aspectRatio[0] + '/' + props.aspectRatio[1];
});

var _default = GameCocosWindow;
exports["default"] = _default;
var templateObject_1;

/***/ }),

/***/ 638:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "GameCocosIframe", ({
  enumerable: true,
  get: function get() {
    return _GameCocosIframe["default"];
  }
}));
Object.defineProperty(exports, "GameCocosWindow", ({
  enumerable: true,
  get: function get() {
    return _GameCocosWindow["default"];
  }
}));

var _GameCocosIframe = _interopRequireDefault(__webpack_require__(393));

var _GameCocosWindow = _interopRequireDefault(__webpack_require__(454));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),

/***/ 405:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _jsxRuntime = __webpack_require__(893);

var _styledComponents = _interopRequireDefault(__webpack_require__(459));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

// const { Body, H1, H2 } = fonts
var TestComponentContainer = _styledComponents["default"].div.withConfig({
  displayName: "TestComponentContainer",
  componentId: "-1y98xaq"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  padding: 16px;\n  width: 360px;\n  text-align: center;\n  color: ", ";\n  background-color: ", ";\n  .heading {\n    font-size: 64px;\n  }\n"], ["\n  border: 1px solid ", ";\n  padding: 16px;\n  width: 360px;\n  text-align: center;\n  color: ", ";\n  background-color: ", ";\n  .heading {\n    font-size: 64px;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.inkBase;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.coolGray62;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.whiteBase;
});

var TestComponent = function TestComponent() {
  return (0, _jsxRuntime.jsx)(TestComponentContainer, {}, void 0);
};

var _default = TestComponent;
exports["default"] = _default;
var templateObject_1;

/***/ }),

/***/ 219:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _Colors = __webpack_require__(34);

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var Dark = {
  colorTokens: _Colors.dark.colors,

  /**
   * @deprecated
   */
  colors: __assign(__assign({}, _Colors.extendedPalette), {
    extendedPalette: _Colors.extendedPalette,
    constant: __assign({}, _Colors.constantColors),
    background: {
      canvas: '#201A19',
      card: '#262221',
      clearCard: 'rgba(255, 255, 255, 0.1)',
      gradient: 'linear-gradient(180deg, rgba(32, 26, 25, 0) 0%, #201A19 21.29%)',
      game: __assign({}, _Colors.gameBackgroundColors)
    },
    neutral: {
      100: 'rgba(255, 255, 255, 0.1)',
      150: 'rgba(255, 255, 255, 0.25)',
      200: 'rgba(255, 255, 255, 0.4)',
      300: 'rgba(255, 255, 255, 0.7)',
      400: 'rgba(255, 255, 255, 0.9)'
    },
    system: {
      primaryAccent: '#FB7E54',
      secondaryAccent: '#50E0D6',
      tertiaryAccent: '#FFD96A',
      success: '#28C97C',
      error: '#E6556A',
      warning: '#FFD96A'
    },
    gradient: {
      primary: 'linear-gradient(180deg, #201A19 0%, #47322B 100%)',
      secondary: 'linear-gradient(180deg, #FFD96A 0%, #FB7E54 100%)'
    }
  }),
  effects: {
    boxShadow: {
      outset: {
        1: '0px 1px 1px rgba(18, 14, 12, 0.07), 0px 1px 4px rgba(18, 14, 12, 0.1)',
        2: '0px 2px 4px rgba(18, 14, 12, 0.22), 0px 3px 19px rgba(18, 14, 12, 0.35)'
      },
      inset: {
        1: 'inset 0px 2.5px 0px rgba(0, 0, 0, 0.22)'
      }
    },
    backgroundBlur: {
      1: 'blur(5px)'
    }
  }
};
var _default = Dark;
exports["default"] = _default;

/***/ }),

/***/ 296:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var Default = {};
var _default = Default;
exports["default"] = _default;

/***/ }),

/***/ 805:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _Colors = __webpack_require__(34);

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var Light = {
  colorTokens: _Colors.light.colors,

  /**
   * @deprecated
   */
  colors: __assign(__assign({}, _Colors.extendedPalette), {
    extendedPalette: _Colors.extendedPalette,
    constant: __assign({}, _Colors.constantColors),
    background: {
      canvas: '#FFFBF7',
      card: '#FFFFFF',
      clearCard: 'rgba(255, 255, 255, 0.1)',
      gradient: 'linear-gradient(180deg, rgba(255, 251, 247, 0) 0%, #FFFBF7 21.81%)',
      game: __assign({}, _Colors.gameBackgroundColors)
    },
    neutral: {
      100: '#E8E6E3',
      150: '#C9C7C3',
      200: '#9B9894',
      300: '#5C5B59',
      400: '#201E1B'
    },
    system: {
      primaryAccent: '#FA6432',
      secondaryAccent: '#36CCC1',
      tertiaryAccent: '#FFCD3D',
      success: '#08B261',
      error: '#E9324C',
      warning: '#FFCD3D'
    },
    gradient: {
      primary: 'linear-gradient(180deg, #FFFFFF 0%, #FFFBF7 100%)',
      secondary: 'linear-gradient(180deg, #FFCD3D 0%, #FA6432 100%)'
    }
  }),
  effects: {
    boxShadow: {
      outset: {
        1: '0px 1px 1px rgba(78, 66, 60, 0.03), 0px 1px 4px rgba(78, 66, 60, 0.04)',
        2: '0px 2px 4px rgba(69, 57, 50, 0.06), 0px 3px 19px rgba(69, 57, 50, 0.15)'
      },
      inset: {
        1: 'inset 0px 1.5px 0px rgba(69, 57, 50, 0.17)'
      }
    },
    backgroundBlur: {
      1: 'blur(5px)'
    }
  }
};
var _default = Light;
exports["default"] = _default;

/***/ }),

/***/ 748:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "DefaultTheme", ({
  enumerable: true,
  get: function get() {
    return _Default["default"];
  }
}));
Object.defineProperty(exports, "LightTheme", ({
  enumerable: true,
  get: function get() {
    return _Light["default"];
  }
}));
Object.defineProperty(exports, "DarkTheme", ({
  enumerable: true,
  get: function get() {
    return _Dark["default"];
  }
}));

var _Default = _interopRequireDefault(__webpack_require__(296));

var _Light = _interopRequireDefault(__webpack_require__(805));

var _Dark = _interopRequireDefault(__webpack_require__(219));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),

/***/ 924:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MicroText2 = exports.MicroText1 = exports.Caption2SemiBold = exports.Caption1Bold = exports.Caption1SemiBold = exports.Caption2 = exports.Caption1 = exports.BodyText3SemiBold = exports.BodyText2Bold = exports.BodyText2SemiBold = exports.BodyText1SemiBold = exports.BodyText3 = exports.BodyText2BoldCaps = exports.BodyText2 = exports.BodyText1 = exports.Subheading3 = exports.Subheading2 = exports.Subheading1 = exports.Heading3 = exports.Heading2 = exports.Heading1 = exports.Title2 = exports.Title1 = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(459));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* stylelint-disable font-family-no-missing-generic-family-keyword */
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var Museo300 = _styledComponents["default"].span.withConfig({
  displayName: "Museo300",
  componentId: "-l5k94l"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 300;\n"], ["\n  font-weight: 300;\n"])));

var Museo700 = _styledComponents["default"].span.withConfig({
  displayName: "Museo700",
  componentId: "-ks20ve"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: 700;\n"], ["\n  font-weight: 700;\n"])));

var Museo900 = _styledComponents["default"].span.withConfig({
  displayName: "Museo900",
  componentId: "-ggfkpv"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: 900;\n"], ["\n  font-weight: 900;\n"])));

var Title1 = _styledComponents["default"].span.withConfig({
  displayName: "Title1",
  componentId: "-17weg4p"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-family: Vesterbro;\n  font-size: 44px;\n  line-height: 52px;\n"], ["\n  font-family: Vesterbro;\n  font-size: 44px;\n  line-height: 52px;\n"])));

exports.Title1 = Title1;

var Title2 = _styledComponents["default"].span.withConfig({
  displayName: "Title2",
  componentId: "-p2nvl1"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-family: Vesterbro;\n  font-size: 38px;\n  line-height: 44px;\n"], ["\n  font-family: Vesterbro;\n  font-size: 38px;\n  line-height: 44px;\n"])));

exports.Title2 = Title2;
var Heading1 = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "Heading1",
  componentId: "-1ognsf"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 40px;\n  line-height: 48px;\n"], ["\n  font-size: 40px;\n  line-height: 48px;\n"])));
exports.Heading1 = Heading1;
var Heading2 = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "Heading2",
  componentId: "-1ix1kdx"
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-size: 32px;\n  line-height: 38px;\n"], ["\n  font-size: 32px;\n  line-height: 38px;\n"])));
exports.Heading2 = Heading2;
var Heading3 = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "Heading3",
  componentId: "-yr2zq7"
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  font-size: 24px;\n  line-height: 28px;\n"], ["\n  font-size: 24px;\n  line-height: 28px;\n"])));
exports.Heading3 = Heading3;
var Subheading1 = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "Subheading1",
  componentId: "-oeaaui"
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  font-size: 20px;\n  line-height: 28px;\n"], ["\n  font-size: 20px;\n  line-height: 28px;\n"])));
exports.Subheading1 = Subheading1;
var Subheading2 = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "Subheading2",
  componentId: "-1e1husg"
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  font-size: 18px;\n  line-height: 24px;\n"], ["\n  font-size: 18px;\n  line-height: 24px;\n"])));
exports.Subheading2 = Subheading2;
var Subheading3 = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "Subheading3",
  componentId: "-tnvcue"
})(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 22px;\n"], ["\n  font-size: 16px;\n  line-height: 22px;\n"])));
exports.Subheading3 = Subheading3;
var BodyText1 = (0, _styledComponents["default"])(Museo300).withConfig({
  displayName: "BodyText1",
  componentId: "-1ynm4qi"
})(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  font-size: 20px;\n  line-height: 28px;\n"], ["\n  font-size: 20px;\n  line-height: 28px;\n"])));
exports.BodyText1 = BodyText1;
var BodyText2 = (0, _styledComponents["default"])(Museo300).withConfig({
  displayName: "BodyText2",
  componentId: "-5xlfd6"
})(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  font-size: 18px;\n  line-height: 24px;\n"], ["\n  font-size: 18px;\n  line-height: 24px;\n"])));
exports.BodyText2 = BodyText2;
var BodyText2BoldCaps = (0, _styledComponents["default"])(BodyText2).withConfig({
  displayName: "BodyText2BoldCaps",
  componentId: "-12lbx17"
})(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  text-transform: uppercase;\n"], ["\n  text-transform: uppercase;\n"])));
exports.BodyText2BoldCaps = BodyText2BoldCaps;
var BodyText3 = (0, _styledComponents["default"])(Museo300).withConfig({
  displayName: "BodyText3",
  componentId: "-ymx1ea"
})(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 22px;\n"], ["\n  font-size: 16px;\n  line-height: 22px;\n"])));
exports.BodyText3 = BodyText3;
var BodyText1SemiBold = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "BodyText1SemiBold",
  componentId: "-1nsu7dz"
})(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  font-size: 20px;\n  line-height: 28px;\n"], ["\n  font-size: 20px;\n  line-height: 28px;\n"])));
exports.BodyText1SemiBold = BodyText1SemiBold;
var BodyText2SemiBold = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "BodyText2SemiBold",
  componentId: "-1u145fz"
})(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  font-size: 18px;\n  line-height: 24px;\n"], ["\n  font-size: 18px;\n  line-height: 24px;\n"])));
exports.BodyText2SemiBold = BodyText2SemiBold;
var BodyText2Bold = (0, _styledComponents["default"])(Museo900).withConfig({
  displayName: "BodyText2Bold",
  componentId: "-5bd32s"
})(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  font-size: 18px;\n  line-height: 24px;\n"], ["\n  font-size: 18px;\n  line-height: 24px;\n"])));
exports.BodyText2Bold = BodyText2Bold;
var BodyText3SemiBold = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "BodyText3SemiBold",
  componentId: "-l2e1ds"
})(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 22px;\n"], ["\n  font-size: 16px;\n  line-height: 22px;\n"])));
exports.BodyText3SemiBold = BodyText3SemiBold;
var Caption1 = (0, _styledComponents["default"])(Museo300).withConfig({
  displayName: "Caption1",
  componentId: "-1sh0w7d"
})(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 20px;\n"], ["\n  font-size: 14px;\n  line-height: 20px;\n"])));
exports.Caption1 = Caption1;
var Caption2 = (0, _styledComponents["default"])(Museo300).withConfig({
  displayName: "Caption2",
  componentId: "-1heisr5"
})(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  font-size: 12px;\n  line-height: 18px;\n"], ["\n  font-size: 12px;\n  line-height: 18px;\n"])));
exports.Caption2 = Caption2;
var Caption1SemiBold = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "Caption1SemiBold",
  componentId: "-10tl23h"
})(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 20px;\n"], ["\n  font-size: 14px;\n  line-height: 20px;\n"])));
exports.Caption1SemiBold = Caption1SemiBold;
var Caption1Bold = (0, _styledComponents["default"])(Museo900).withConfig({
  displayName: "Caption1Bold",
  componentId: "-rp72od"
})(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 20px;\n"], ["\n  font-size: 14px;\n  line-height: 20px;\n"])));
exports.Caption1Bold = Caption1Bold;
var Caption2SemiBold = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "Caption2SemiBold",
  componentId: "-45l7fd"
})(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  font-size: 12px;\n  line-height: 18px;\n"], ["\n  font-size: 12px;\n  line-height: 18px;\n"])));
exports.Caption2SemiBold = Caption2SemiBold;
var MicroText1 = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "MicroText1",
  componentId: "-bct97g"
})(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  text-transform: uppercase;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.1em;\n"], ["\n  text-transform: uppercase;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.1em;\n"])));
exports.MicroText1 = MicroText1;
var MicroText2 = (0, _styledComponents["default"])(Museo700).withConfig({
  displayName: "MicroText2",
  componentId: "-123yjsw"
})(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  text-transform: uppercase;\n  font-size: 10px;\n  line-height: 16px;\n  letter-spacing: 0.1em;\n"], ["\n  text-transform: uppercase;\n  font-size: 10px;\n  line-height: 16px;\n  letter-spacing: 0.1em;\n"])));
exports.MicroText2 = MicroText2;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;

/***/ }),

/***/ 317:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _styledComponents = __webpack_require__(459);

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var GlobalStyle = (0, _styledComponents.createGlobalStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  html, body {\n    font-family: 'MuseoSans', sans-serif;\n  }\n\n  body {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"], ["\n  html, body {\n    font-family: 'MuseoSans', sans-serif;\n  }\n\n  body {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"])));
var _default = GlobalStyle;
exports["default"] = _default;
var templateObject_1;

/***/ }),

/***/ 115:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _exportNames = {
  TestComponent: true,
  colors: true,
  GlobalStyle: true
};
Object.defineProperty(exports, "TestComponent", ({
  enumerable: true,
  get: function get() {
    return _TestComponent["default"];
  }
}));
Object.defineProperty(exports, "GlobalStyle", ({
  enumerable: true,
  get: function get() {
    return _globalStyles["default"];
  }
}));
exports.colors = void 0;

var _TestComponent = _interopRequireDefault(__webpack_require__(405));

var colors = _interopRequireWildcard(__webpack_require__(34));

exports.colors = colors;

var _globalStyles = _interopRequireDefault(__webpack_require__(317));

var _Theme = __webpack_require__(748);

Object.keys(_Theme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Theme[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Theme[key];
    }
  });
});

var _GameContainer = __webpack_require__(638);

Object.keys(_GameContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _GameContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GameContainer[key];
    }
  });
});

var _Button = __webpack_require__(305);

Object.keys(_Button).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Button[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Button[key];
    }
  });
});

var _Typography = __webpack_require__(924);

Object.keys(_Typography).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Typography[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Typography[key];
    }
  });
});

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),

/***/ 941:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.hexToRGB = exports.changeColorShade = void 0;
var MAX_RGB = 255;
var MIN_RGB = 0;
var R_OFFSET = 16;
var B_OFFSET = 8;
var B_MASK = 0x00FF;
var G_MASK = 0x0000FF;

var placeWithinBounds = function placeWithinBounds(num) {
  var result;

  if (num > MAX_RGB) {
    result = MIN_RGB;
  } else if (num < MIN_RGB) {
    result = MIN_RGB;
  } else {
    result = num;
  }

  return result;
};

var changeColorShade = function changeColorShade(colorHex, amt) {
  var usePound = false;

  if (colorHex[0] === '#') {
    colorHex = colorHex.slice(1);
    usePound = true;
  }

  var num = parseInt(colorHex, 16);
  var r = placeWithinBounds((num >> R_OFFSET) + amt);
  var b = placeWithinBounds((num >> B_OFFSET & B_MASK) + amt);
  var g = placeWithinBounds((num & G_MASK) + amt);
  return (usePound ? '#' : '') + (g | b << B_OFFSET | r << R_OFFSET).toString(16);
};

exports.changeColorShade = changeColorShade;

var hexToRGB = function hexToRGB(hex, alpha) {
  var r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  } else {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }
};

exports.hexToRGB = hexToRGB;

/***/ }),

/***/ 167:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// Module
var code = "<!doctype html> <html lang=\"\"> <head> <meta charset=\"utf-8\"> <meta name=\"viewport\" content=\"width=device-width,initial-scale=1\"> <link rel=\"icon\" href=\"data:,\"> <style>body,canvas,div,html{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;overflow:hidden}canvas:focus-visible{outline:0}#game-manager{width:100vw;height:100vh}</style> </head> <body> <div class=\"cocos3\" id=\"game-manager\"> <canvas id=\"gameCanvas\"/> </div> <script>var topOrigin=\"*\",topSource=null;function onResize(e,i){if(window.cc&&window.cc.view){document.getElementById(\"game-manager\");window.cc.view.setCanvasSize(e,i),window.cc.view.setDesignResolutionSize(window.cc.view._originalDesignResolutionSize.width,window.cc.view._originalDesignResolutionSize.height)}}window.sendToJavaScript=(e,i)=>{topSource&&(Array.isArray(e)?topSource.postMessage({lumos:!0,eventName:e[0],eventData:e[1]},topOrigin):topSource.postMessage({lumos:!0,eventName:e,eventData:i},topOrigin))},window.addEventListener(\"message\",(function(e){try{if(!e.data||!e.data.lumos||!e.data.command)return;switch(topOrigin=e.origin,topSource=e.source,e.data.command){case\"init\":window.Lumos=e.data.vars;const i=document.createElement(\"script\");i.src=e.data.url,document.body.appendChild(i);break;case\"resize\":onResize(e.data.width,e.data.height)}}catch(e){}})),window.addEventListener(\"unload\",(function(){window.cc&&window.cc.director&&(window.cc.director.purgeCachedData(),window.cc.director.purgeDirector(),window.cc.director.end())}))</script> </body> </html> ";
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (code);

/***/ }),

/***/ 96:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;


/***/ }),

/***/ 418:
/***/ ((module) => {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 251:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(418);var f=__webpack_require__(619),g=60103;exports.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");exports.Fragment=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 893:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(251);
} else {}


/***/ }),

/***/ 619:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 459:
/***/ ((module) => {

"use strict";
module.exports = require("styled-components");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(115);
/******/ 	var __webpack_export_target__ = exports;
/******/ 	for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
/******/ 	if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ 	
/******/ })()
;